import React, { ReactNode, useMemo } from 'react';

type Props = {
  component: ReactNode;
  count: number;
};

const RenderComponentXTimes: React.FC<Props> = ({ component, count }) => {
  const renderedComponents = useMemo(() => new Array(count).fill(null), [count]);

  return renderedComponents.map((_, i) => <React.Fragment key={`skeleton-${i}`}>{component}</React.Fragment>);
};
export { RenderComponentXTimes };
